export default __webpack_public_path__ + "static/media/platinum.491e238a.png";